module.exports = __webpack_public_path__ + "static/media/back.615dbad8.png";